import { STATUS_STYLES } from "@/lib/ui";

export function StatusBadge({ status = "UNKNOWN", small }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.UNKNOWN;
  return (
    <span
      data-testid="device-status-pill"
      className="inline-flex items-center gap-1.5 rounded-full border font-mono font-medium uppercase tracking-wide"
      style={{
        color: s.text, background: s.bg, borderColor: s.border,
        fontSize: small ? "10px" : "11px", padding: small ? "1px 7px" : "2px 9px",
      }}
    >
      <span className={"rounded-full " + (status === "ONLINE" ? "pulse-dot" : "")}
            style={{ width: 6, height: 6, background: s.dot }} />
      {status}
    </span>
  );
}
